import React from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import { useDotButton } from './EmblaCarouselDotButton'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import useEmblaCarousel from 'embla-carousel-react'
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material'
import Autoplay from 'embla-carousel-autoplay'
import { JSX } from 'react/jsx-runtime'

type CarouselInput =
  {
    title: string
    body: string
    imgLink: string
    imgAlt: string
    a?: string
    aLink?: string
  }

function CreateCarouselArray(input: CarouselInput[], isSmall: boolean) {
  const fontSize = isSmall ? '.8rem' : 'auto'
  var componentArray: { values: CarouselInput; component: JSX.Element }[] = [];
  input.map((value, i) => {
    componentArray.push({
      values: value,
      component: <div className='Item'>
        <div className='SubDiv'>
          <Typography variant='h5'>
            {value.title}
          </Typography>

          <Paper style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem', background: 'white', marginRight: '0.5rem' }}>
            <img alt={value.imgAlt} src={value.imgLink} style={{ maxWidth: '100px', alignSelf: 'center' }}></img>
          </Paper>
        </div>
        <Typography variant='subtitle1' style={{ fontSize: fontSize }}>
          {value.body}
        </Typography>
        {
          value.a &&
          <a href={value.aLink} style={{ fontSize: isSmall ? 'x-small' : '1rem' }}>
            {value.a}
          </a>
        }
      </div>
    })
  })
  return componentArray;
}

function CreateCarousel(input: CarouselInput) {

  const theme = useTheme();
  const isSmall = !useMediaQuery(theme.breakpoints.up('lg'))
  const fontSize = isSmall ? '.8rem' : 'auto'
  return {
    values: input,
    component: <div className='Item'>
      <div className='SubDiv'>
        <Typography variant='h5'>
          {input.title}
        </Typography>

        <Paper style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem', background: 'white' }}>
          <img alt={input.imgAlt} src={input.imgLink} style={{ maxWidth: '100px', alignSelf: 'center' }}></img>
        </Paper>
      </div>
      <Typography variant='subtitle1' style={{ fontSize: fontSize, marginLeft: '1rem' }}>
        {input.body}
      </Typography>
      {
        input.a &&
        <a href={input.aLink} style={{ fontSize: isSmall ? 'x-small' : '1rem' }}>
          {input.a}
        </a>
      }
    </div>
  }

}

type PropType = {
  slides: any[]
  options?: EmblaOptionsType
}

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay({ playOnInit: true, delay: 3000 })])

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return (
    <section className="embla" dir="rtl">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((value, index) => (
            <div className="embla__slide" key={index}>
              <div className="embla__slide__number">
                {
                  value.component ? value.component : value
                }
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={() => { emblaApi?.scrollTo(0) }} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </section>
  )
}

export { EmblaCarousel, CreateCarousel, CreateCarouselArray }
export type { CarouselInput }